import React from 'react';
import PropTypes from 'prop-types';

import { Translate } from 'react-redux-i18n';
import GenericSelection from '../Common/GenericSelection';

const propTypes = {
  dependentValues: PropTypes.shape({
    IsListView: PropTypes.bool,
    IsButton: PropTypes.bool,
    ListViewType: PropTypes.string,
  }),
  handleCheckBoxClick: PropTypes.func,
  handleViewTypeSelect: PropTypes.func,
};

const defaultProps = {
  dependentValues: {},
  handleCheckBoxClick: () => {},
  handleViewTypeSelect: () => {},
};

const Category2DisplayOptionsFormatter = React.createClass({
  getInitialState() {
    return {
      isListView: true,
      isButton: false,
      listViewType: '',
    };
  },
  componentWillMount() {
    const { IsListView, IsButton, ListViewType } = this.props.dependentValues;
    const isListView = (typeof IsListView === 'boolean') ? IsListView : true;
    const isButton = (typeof IsButton === 'boolean') ? IsButton : false;
    const listViewType = ListViewType || 'horizontal-1';
    this.setState({ isListView, isButton, listViewType });
  },
  componentWillReceiveProps(nextProps) {
    if (nextProps.dependentValues && nextProps.dependentValues !== this.props.dependentValues) {
      const { IsListView, IsButton, ListViewType } = nextProps.dependentValues;
      const isListView = (typeof IsListView === 'boolean') ? IsListView : true;
      const isButton = (typeof IsButton === 'boolean') ? IsButton : false;
      const listViewType = ListViewType || 'horizontal-1';
      this.setState({ isListView, isButton, listViewType });
    }
  },
  render() {
    const viewOptions = [
      { value: 'horizontal-1', label: 'Horizontal (1 Row)' },
      { value: 'horizontal-2', label: 'Horizontal (2 Rows)' },
      { value: 'vertical', label: 'Vertical' },
      { value: 'middle-image', label: 'Middle Image' },
    ];
    const { isListView, isButton, listViewType } = this.state;
    return (
      <div className="category2-display-options">
        <div className="category2-view-type-b2c">
          <label htmlFor="sectioned-list-option">
            <input
              type="checkbox"
              name="sectioned-list-option"
              checked={isListView}
              onClick={() => {
                this.props.handleCheckBoxClick(this.props, 'IsListView');
                this.setState({ isListView: !isListView });
              }}
            />
            <Translate value="sectioned_list" />
          </label>
          <GenericSelection
            options={viewOptions}
            value={listViewType}
            setSelected={(e) => {
              this.props.handleViewTypeSelect(e, this.props.dependentValues);
              this.setState({ listViewType: e.value });
            }}
            disabled={!isListView}
          />
        </div>
        <label htmlFor="button-option">
          <input
            type="checkbox"
            name="button-option"
            checked={isButton}
            onClick={() => {
              this.props.handleCheckBoxClick(this.props, 'IsButton');
              this.setState({ isButton: !isButton });
            }}
          />
          <Translate value="button" />
        </label>
      </div>
    );
  },
});

Category2DisplayOptionsFormatter.propTypes = propTypes;
Category2DisplayOptionsFormatter.defaultProps = defaultProps;

export default Category2DisplayOptionsFormatter;



// WEBPACK FOOTER //
// ./master/jsx/components/Products/Category2DisplayOptionsFormatter.jsx